import React from 'react';
import StepContent from './StepContent';

const RECOMMENDATIONS_HELPER_TEXT = 'Once you verify your page with Facebook, you should be able to refresh the Facebook tool and create a Boosted Post or Post Only.';

// The below are wrapped in an array to allow for a mix of jsx and strings
// src: https://stackoverflow.com/questions/19266197/reactjs-convert-html-string-to-jsx
const RECOMMENDATIONS_CHECKLIST = [
  [
    'Now that your TXT record has been installed, you can click the ',
    <span className="blue">Verify</span>,
    ' button to complete the verification process',
  ],
  [

    'Once your domain is verified, you will also need to add your Page so that you are able to post to it. You can click on your domain and then select ',
    <span className="blue">&quot;Assign Pages&quot;</span>,
    '.',
  ],
  [
    'Select the pages you would like to add, and then ',
    <span className="blue">Save Changes</span>,
    '.',
  ],
];

export const Recommendations = () => (
  <StepContent
    title="Recommendations"
    helperText={RECOMMENDATIONS_HELPER_TEXT}
    checklist={RECOMMENDATIONS_CHECKLIST}
  />
);
